/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConceptRelationType } from './conceptRelationType';
import type { ConceptEdgeDescription } from './conceptEdgeDescription';

/**
 * A relationship between two concept nodes.
 */
export interface ConceptEdge {
  sourceId: string;
  targetId: string;
  relation: ConceptRelationType;
  description?: ConceptEdgeDescription;
}
